import React from 'react';
import { 
    Grid, Box, Typography, Paper, Table, TableBody, TableCell, 
    TableContainer, TableHead, TableRow, Divider 
} from '@mui/material';
import { Select, Form } from 'antd';
import InputForm from "../../InputT";
import dayjs from 'dayjs';

const Tab1 = (props: { 
    form?: any, 
    glResultats: any[],
    listTypes: any[],
    listStatuts: any[],
    listProduits: any[],
    listGestionnaires: any[],
    listEtapes: any[],
    onTypeChange: (val: string) => void,
    statusLoading: boolean;
}) => {
    return (
        <div className='tabItemAuto'>
            {/* Observation 6 : Conservé en absolute selon instruction, mais élargi à 90% pour plus de confort */}
            <Grid container className='border' sx={{ width: "85%", position: "absolute", p: 2 }}>
                
                {/* TITRE UNIQUE POUR LE CONTENEUR GLOBAL */}
    <legend>Paramètres de filtrage du journal</legend>

        

    {/* --- COLONNE GAUCHE : PÉRIODE & PRODUITS --- */}
    <Grid item xs={12} md={6} sx={{ pr: 2 }}>
        
        
        

        <Form.Item 
            label="Type de financement" 
            name="TYPEFINANCEMENT"
            labelCol={{ span: 7 }}  
            wrapperCol={{ span: 17 }}
        >
            <Select
                placeholder="Sélectionner"
                style={{ width: '100%' }}
                onChange={props.onTypeChange}
                options={props.listTypes.map(t => ({ value: t.CODE, label: t.LIBELLE }))}
                allowClear
            />
        </Form.Item>

        <Form.Item 
            label="Produit spécifique" 
            name="CODEPRODUIT"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 17 }}
        >
            <Select
                placeholder="Sélectionner"
                style={{ width: '100%' }}
                disabled={props.listProduits.length === 0}
                options={props.listProduits.map(p => ({ value: p.CODE, label: p.LIBELLE }))}
                allowClear
            />
        </Form.Item>

        <Form.Item 
            label="Gestionnaire" 
            name="GESTIONNAIRE"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 17 }}
        >
            <Select
                placeholder="Sélectionner"
                style={{ width: '100%' }}
                disabled={props.listGestionnaires.length === 0}
                options={props.listGestionnaires.map((g: any) => ({ value: g.CODE, label: g.LIBELLE }))}
                allowClear
            />
        </Form.Item>
    </Grid>

    {/* --- COLONNE DROITE : PERSONNEL & ÉTATS --- */}
    <Grid item xs={12} md={6} className='border-left' sx={{ pl: 2 }}>

        <Form.Item 
            label="Statut" 
            name="STATUT"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 17 }}
        >
            <Select 
                placeholder={props.glResultats.length > 0 ? "Filtrer par statut" : "Consultez d'abord pour voir les statuts"} 
                style={{ width: '100%' }} 
                loading={props.statusLoading} 
                disabled={props.glResultats.length === 0}
                options={props.listStatuts.map(s => ({ value: s.CODE, label: s.LIBELLE }))}
                allowClear 
            />
        </Form.Item>

        <Form.Item 
            label="Étape actuelle" 
            name="ETAPEACTUELLE"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 17 }}
        >
            <Select
                placeholder="Sélectionner"
                style={{ width: '100%' }}
                disabled={props.listEtapes.length === 0}
                options={props.listEtapes.map(e => ({ value: e.CODE, label: e.LIBELLE }))}
                allowClear
            />
        </Form.Item>

        
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={6}>
                <InputForm width={7} label="Période Début" name="DATEDEBUT" type="date" />
            </Grid>
            <Grid item xs={6}>
                <InputForm width={7} label="Période Fin" name="DATEFIN" type="date" />
            </Grid>
        </Grid>
       
    </Grid>

    {/* --- ZONE DE RÉSULTATS (Tableau) --- */}
    <Grid item xs={12} sx={{ mt: 2 }}>
        {/* ... votre TableContainer ici ... */}
    </Grid>


                {/* --- ZONE DE RÉSULTATS --- */}
                <Grid item xs={12} sx={{ mt: 1 }}>
                    <Divider>
                        <Typography variant="overline" sx={{ fontWeight: 'bold', color: '#116599' }}>
                            Journal Détaillé - ({props.glResultats.length} dossiers)
                        </Typography>
                    </Divider>
                    <TableContainer 
                        component={Paper} 
                        elevation={2} 
                        sx={{ 
                            mt: 1, 
                            maxHeight: 'calc(100vh - 380px)', 
                            minHeight: '250px', 
                            overflowX: 'auto',
                            '&::-webkit-scrollbar': { height: '5px' }, // Observation : Scrollbar fine
                            '&::-webkit-scrollbar-track': { backgroundColor: '#f1f1f1' },
                            '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '10px' },
                            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#116599' }
                        }}
                    >
                        <Table stickyHeader size="small" sx={{ minWidth: 3000 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Date Demande</TableCell>                
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>N° Demande</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>N° Financement</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Client</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Type Financement</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Code Produit</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Montant Demandé</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Montant Payé</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Montant Restant</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Statut</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Étape Actuelle</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Prochaine Étape</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Responsable</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Priorité</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Niveau Alerte</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Jours Retard</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Délai Max</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Agence</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Gestionnaire</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Action Recommandée</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Documents Requis</TableCell>
                                    <TableCell sx={{ bgcolor: '#116599', color: 'white', fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid rgba(255, 255, 255, 0.2)', borderBottom: '2px solid #0d4a70' }}>Commentaire</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.glResultats.map((row, index) => (
                                    <TableRow key={index} hover sx={{ bgcolor: index % 2 === 0 ? '#ffffff' : '#f9f9f9' }}>
                                        {/* Observation 2 : Affichage Date/Heure sans underscore orphelin */}
                                        <TableCell sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0', textAlign: 'center' }}>
                                            {row.DATEDEMANDE && (
                                                <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                                                    <span>{dayjs(row.DATEDEMANDE).format('DD/MM/YYYY')}</span>
                                                    <span style={{ fontSize: '0.7rem', color: '#666' }}>{dayjs(row.DATEDEMANDE).format('HH:mm')}</span>
                                                </Box>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.NUMERODEMANDE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.NUMEROFINANCEMENT}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.NOMCLIENT}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.TYPEFINANCEMENT}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.CODEPRODUIT}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', color: '#116599', fontWeight: 'bold', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0', textAlign: 'right' }}>
                                            {row.MONTANTDEMANDE ? new Intl.NumberFormat('fr-FR').format(row.MONTANTDEMANDE) : '0'}
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', color: '#116599', fontWeight: 'bold', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0', textAlign: 'right' }}>
                                            {row.MONTANTPAYE ? new Intl.NumberFormat('fr-FR').format(row.MONTANTPAYE) : '0'}
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', color: 'red', fontWeight: 'bold', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0', textAlign: 'right' }}>
                                            {row.MONTANTRESTANT ? new Intl.NumberFormat('fr-FR').format(row.MONTANTRESTANT) : '0'}
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>
                                            <Box sx={{ 
                                                fontWeight: 'bold',  textTransform: 'uppercase'
                                            }}>
                                                {row.STATUT}
                                            </Box>
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.ETAPEACTUELLE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', color: '#666', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.PROCHAINEETAPE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.RESPONSABLE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>
                                            <span style={{ color: row.PRIORITEACTION === 'HAUTE' ? 'red' : 'inherit' }}>{row.PRIORITEACTION}</span>
                                        </TableCell>
                                        {/* Observation 4 : Fallback sur NIVEAUALERTE si NIVEAUALERT est vide */}
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.NIVEAUALERT || row.NIVEAUALERTE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.JOURSRETARD}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.DELAIMAXACTION}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.CODEAGENCE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.GESTIONNAIRE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.ACTIONRECOMMANDEE}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.DOCUMENTSREQUIS}</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap', borderRight: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0' }}>{row.COMMENTAIRETRAITEMENT}</TableCell>
                                    </TableRow>
                                ))}
                                {props.glResultats.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={22} align="center" sx={{ py: 3 }}>
                                            Aucune donnée trouvée.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    );
};

export default Tab1;